import "./loader.css";
import { Box } from "@mui/material";

const Spinner = () => {
  return <Box className="spinner"></Box>;
};

export default Spinner;
